export default __webpack_public_path__ + "static/media/loading.77f00c1f.svg";